import { render, staticRenderFns } from "./DollarSVG.vue?vue&type=template&id=42eb87df"
import script from "./DollarSVG.vue?vue&type=script&lang=js"
export * from "./DollarSVG.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports